import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HowToTicketsService {

  constructor(private http: HttpClient) { }

  getHowToTicketsInfo(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/how-to-tickets/info`;
    return this.http.get(url);
  }
}
